import React from 'react';
import { Box } from '@mui/material';
import RiskMonitorChart from './RiskMonitorChart';
import MarketBreadthChart from './MarketBreadthChart';

const RiskAndBreadthSection = ({ macroScore, marketBreadth }) => {
  if (!macroScore || !marketBreadth) return null;

  return (
    <Box 
      sx={{ 
        display: 'grid', 
        gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, 
        gap: 3, 
        mb: 3 
      }}
    >
      {/* Risk Monitor Chart */}
      <RiskMonitorChart macroScore={macroScore} />

      {/* Market Breadth Chart */}
      <MarketBreadthChart marketBreadth={marketBreadth} />
    </Box>
  );
};

export default RiskAndBreadthSection;

